export const FETCH_LIST = 'FETCH_LIST'
export const RECEIVE_LIST = 'RECEIVE_LIST'
export const FETCH_DETAIL = 'FETCH_DETAIL'
export const RECEIVE_DETAIL = 'RECEIVE_DETAIL'
export const FETCH_WALLET_SUPERVISED = 'FETCH_WALLET_SUPERVISED'
export const RECEIVE_WALLET_SUPERVISED = 'RECEIVE_WALLET_SUPERVISED'
export const CLEAR_DETAIL = 'CLEAR_DETAIL'
export const CLEAR_LIST = 'CLEAR_LIST'
export const CLEAR_WALLET_SUPERVISED = 'CLEAR_WALLET_SUPERVISED'
